import React, { useCallback } from 'react';
import { PaymentSource } from '../../../constants';
import { reportError } from '../../../lib/reportError';
import { useErrorModal } from '../../../hooks/useErrorModal';
import {
  useCart,
  useUpdateCartMutation,
  CartUpdateAction,
  CartUpdatePropertyName
} from '../../../hooks/useCart';
import { useChangePaymentSource } from '../../CheckoutPaymentSources';
import { CheckoutSection } from '../../CheckoutSection';
import { useCheckoutFormStates } from '../../CheckoutFormStates';
import { PayPalShippingAndPayment, Mode } from '../PayPalShippingAndPayment';

export const CheckoutPayPalShippingAndPayment: React.FC = () => {
  const { showErrorModal } = useErrorModal();
  const {
    cart: {
      attributes: { addressId, paypalClientToken }
    }
  } = useCart();
  const [updateCart] = useUpdateCartMutation();
  const changePaymentSource = useChangePaymentSource();
  const { setFormState } = useCheckoutFormStates();

  const onSwitchToCard = useCallback(async () => {
    try {
      await updateCart(CartUpdateAction.PaymentSource, {
        [CartUpdatePropertyName.PaymentSource]: PaymentSource.Braintree
      });
    } catch (error) {
      reportError('CHECKOUT_PAYPAL_SWITCH_TO_CARD', error);
      showErrorModal();
    }
  }, [showErrorModal, updateCart]);

  const onSubmit = useCallback(
    () => changePaymentSource(PaymentSource.PayPal),
    [changePaymentSource]
  );

  const onModeChange = useCallback(
    (mode: Mode) => {
      setFormState('shippingAddress', mode === Mode.Resting ? 'closed' : 'open');
      setFormState('paymentMethod', mode === Mode.Resting ? 'closed' : 'open');
    },
    [setFormState]
  );

  return (
    <CheckoutSection title="Shipping &amp; Payment">
      <PayPalShippingAndPayment
        paypalClientToken={paypalClientToken}
        addressId={addressId}
        onSwitchToCard={onSwitchToCard}
        onSubmit={onSubmit}
        onModeChange={onModeChange}
        showPayPalButtonTooltip
      />
    </CheckoutSection>
  );
};
